<template>

<section class="models-list pt-5 pb-5">
    <div class="container">
        <div class="row mb-4">
            <div class="col-12">
                <h2 class="text-center">
                    Recomended Models
                </h2>
            </div>
        </div>
        <div v-if='isReady' class="row d-flex justify-content-center">
            <div v-for='m in models' class="col-xl-3 col-lg-4 col-sm-6 col-12 d-flex justify-content-center">
                <div class="model-card border-grid mb-4">
                    <a :href="url('onlyfans-models/' + m.slug)" class="img-link d-block position-relative">
                        <span class="img-overway text-uppercase">
                            <span>
                                See <br> profile
                                <span class="material-icons-round d-block">double_arrow</span>
                            </span>
                        </span>
                        <img :alt="m.name" :src="m.avatar_thumb" class="img-fluid">
                    </a>

                    <div class="model-info">
                        <div class="model-stats d-flex justify-content-center mt-2 mb-2">
                            <!-- <fav-btn :m='m.id' :l='m.likes'></fav-btn>  -->

                            <span class="views">
                                <span class="material-icons-round">&#xe8f4;</span>
                                {{ m.previews }}
                            </span>
                            <span class="views">
                                <span class="material-icons-round">&#xe412;</span>
                                {{ m.images }}
                            </span>
                            <span class="views">
                                <span class="material-icons-round">&#xe04b;</span>
                                {{ m.videos }}
                            </span>
                        </div>
                        <h3 class="model-name">
                            <a :href="url('onlyfans-models/' + m.slug)">{{ m.name }}</a>
                        </h3>
                        <!-- <div>
                            {{ m.descr }}...
                        </div> -->
                    </div>
                    
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 text-center">
                <a :href="url('onlyfans-models')" class="btn btn-primary">All Models</a>
            </div>
        </div>
    </div>
</section>

</template>

<script>
    export default {

        mounted() {
            this.getData();
        },

        props : ['n'],

        created() {
            
            if( typeof this.n == 'number' ) {
                this.num = this.n;
            }

        },

        data() {
            return {
                isReady : false,
                isLoading : false,
                num     : 8,
                models  : []
            }
        },

        methods : {

            getData() {

                this.ajax.call("el:glt", { n : this.num }, (r) => {
                    if( r.status == 'success' ) {
                        this.models = r.data;
                        this.isReady = true;
                    }
                })
            }

        }

    }
</script>
